<template>
  <section class="pagination">
    <div class="currentPage" v-if="!isMobile">현재페이지{{ currentPage }}/{{ lastPage }}</div>
    <div class="paging" :class="{isMobile:isMobile}">
      <ul>
        <li>
          <a
            href="javascript:void(0)"
            @click="paginatePage(currentLast - totalvisible)"
            :class="{ disable: currentLast - totalvisible < 1 }"
          >
            이전
          </a>
        </li>
        <template v-for="(n, index) in currentLast" :key="index">
          <li v-if="index >= currentLast - totalvisible" :class="{ active: n === currentPage }" @click="paginatePage(n)">
            <a
              href="javascript:void(0)"
              
              :class="{ active: n === currentPage }"
            >
              {{ n }}
            </a>
          </li>
        </template>
        <li>
          <a
            href="javascript:void(0)"
            @click="paginatePage(currentLast + 1)"
            :class="{ disable: currentLast + 1 > lastPage }"
          >
            다음
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    store:{}, 
    collection:{},
    isMobile:{default:false},
    totalvisible:{type:Number,default:10}
  },
  data() {
    return {
      link: [],      
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.$store.state[this.store][this.collection].current_page;
      },
      set(value) {
        console.log("currentPage 변동 발생", value);
        this.$store.commit(this.store + "/setCurrentPage", value);
        this.paginatePage(value);
      },
    },
    lastPage: {
      get() {
        return this.$store.state[this.store][this.collection].last_page;
      },
    },
    currentLast() {
      const last_page = this.lastPage;
      const current_page = this.currentPage; //현재 페이지
      if (last_page && current_page) {
        let tv = 0;
        const total = parseInt(this.totalvisible);
        if (current_page % this.totalvisible == 0) {
          tv = (current_page / this.totalvisible) * total;
        } else {
          tv = parseInt((current_page + total) / total) * total;
        }
        return tv > last_page ? last_page : tv;
      } else {
        return this.totalvisible;
      }
    },
  },
  methods: {
    paginatePage(pageNumber) {
      //pageNumber 판단
      if (pageNumber < 1) {
        console.log("젤 첫 페이지");
        return;
      }
      if (pageNumber > this.lastPage) {
        console.log("마지막 페이지");
        return;
      }
      this.$emit("paging", pageNumber);
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination {
  display:flex;
  padding-bottom:20px;
  .paging{
       flex:1 auto;
    ul {
        display: flex;
        justify-content: space-evenly;
        font-size:14px;
        li {
        .active {
            color: red;
            font-weight: bold;
        }
        .disable {
            color: #ccc;
            text-decoration: none;
        }
        }
    }
  }
  .isMobile{
    li{
      border: 1px solid #ccc;
      padding:5px 10px;
      border-radius: 5px;     
    }
    .active {
      color: #fff !important;
      background:rgb(58, 89, 189);
      font-weight: bold;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;

    }
  }

}
</style>
